import Box from '../../Box/Box';
import InputPill from '../../Common/InputPill/InputPill';
import Qr from '../../Common/Qr/Qr';
import { useTranslation } from 'react-i18next';
import { WelletContext } from '../../../context/WelletContext';
import { useContext, useState, useCallback } from 'react';
import { Toast } from '../../Common/Toast/Toast';
import { formatExpiration } from '../../../helpers/dates';
import { useSelector } from 'react-redux';

const ShareReservation = ({ link, expirationDate }) => {
  const app = useSelector((state) => state.app);
  const { t } = useTranslation();
  const welletContext = useContext(WelletContext);
  const [copyStatus, setCopyStatus] = useState(null);

  const copyToClipboard = useCallback(async (text) => {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text);
      } else {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-9999px';
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
      }
      setCopyStatus('success');
      setTimeout(() => setCopyStatus(null), 2000);
    } catch (err) {
      console.error('Error al copiar:', err);
      setCopyStatus('error');
      setTimeout(() => setCopyStatus(null), 2000);
    }
  }, []);

  const handleCopyLink = async () => {
    await copyToClipboard(link);
  };

  const handleShareWhatsapp = async () => {
    const text = t('confirmYourReservationDescription');

    if (navigator.share) {
      try {
        await navigator.share({
          title: t('confirmYourReservation'),
          text: text,
          url: link,
        });
        return;
      } catch (err) {
        if (err.name === 'AbortError') return;
      }
    }

    await copyToClipboard(link);
  };

  return (
    <>
      <div className='section-title'>{t('generatedLink')}</div>
      <Box>
        <div className='text-secondary font-tiny'>{t('generatedLinkDescription')}</div>
        <div className='text-center mt-3text-secondary font-tiny d-flex justify-content-center mt-3'>
          <Qr
            qrUrl={encodeURIComponent(link)}
            welletContext={welletContext}
            size={200}
            logoBorder='ROUNDED'
          />
        </div>
        <div className='mt-3'>
          <div className='text-secondary font-tiny mb-2'>{t('paymentLink')}</div>
          <InputPill
            value={link}
            name='paymentLink'
            type='text'
            autoComplete='off'
            className='w-100'
            readOnly={true}
          />
        </div>
        <div className='mt-2'>
          <div className='row'>
            <div className='col-6 pr-1'>
              <button
                className='btn btn-secondary btn-pill w-100'
                style={{
                  fontSize: '.85rem',
                  lineHeight: 'initial',
                  padding: '.25rem',
                  height: '42px',
                  fontWeight: '500',
                }}
                onClick={handleCopyLink}
              >
                {t('copyLink')}
              </button>
            </div>
            <div className='col-6 pl-1'>
              <button
                className='btn btn-primary btn-pill w-100'
                style={{
                  fontSize: '.85rem',
                  lineHeight: 'initial',
                  padding: '.25rem',
                  height: '42px',
                  fontWeight: '500',
                }}
                onClick={handleShareWhatsapp}
              >
                {t('shareByWhatsapp')}
              </button>
            </div>
          </div>
        </div>
      </Box>
      <div>
        <Box>
          <div className='text-secondary font-tiny capitalize'>{t('linkExpirationDate')}</div>
          <div className='font-tiny fw-600 mt-2'>
            {formatExpiration(new Date(expirationDate), t, app.language)}
          </div>
          <div className='text-secondary font-tiny mt-2'>{t('afterExpirationLinkDescription')}</div>
        </Box>
      </div>
      {copyStatus === 'success' && (
        <Toast
          bottom={'15px'}
          zIndex={100000}
          type={'success'}
          message={t('linkCopied')}
          delay={20}
        />
      )}
    </>
  );
};

export default ShareReservation;
